import { CloseOutlined } from '@mui/icons-material';
import { Button, Drawer, IconButton } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { MenuIcon } from 'Sui_Icons';
import { Sidebar } from '../../Sidebar/Sidebar';
import { SidebarUser } from '../../SidebarUser/SidebarUser'
import { UserProfile } from './UserProfile';

export const ResponsiveMenu = ({infoUser}) => {

    const [visiblity, setVisiblity] = useState(false)

    const location = useLocation()

    useEffect(() => setVisiblity(false), [location])

    const toggleDrawer = (state) => () => setVisiblity(state);


    return (
        <div>
            <IconButton onClick={toggleDrawer(true)}><MenuIcon /></IconButton>
            <Drawer
                anchor={'left'}
                open={visiblity}
                onClose={toggleDrawer(false)}
                sx={{
                    display: { xs: 'flex', lg: 'none' },
                    zIndex:2001,
                    '& .MuiPaper-root': {
                        alignItems: 'center',
                        boxSizing: 'border-box',
                        background: '#fff',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        display: { xs: 'flex', lg: 'none' },
                        flexDirection: 'column',
                        height: '100%',
                        overflowX: 'hidden',
                        margin: 0,
                        px: 3,
                        py: 1
                    }
                }}
            >
                <Box width={'100%'} mb={2} ml={-2}>
                    <IconButton onClick={toggleDrawer(false)}>
                        <CloseOutlined />
                    </IconButton>
                </Box>
                <UserProfile />
                {(infoUser?.role == 'admin' || infoUser?.role == 'creator') ? <Sidebar useInMobile={true} /> : <SidebarUser useInMobile={true} />}
            </Drawer>
        </div>
    )
}
